import HowItWorksSteps from '../../../components/feature/HowItWorksSteps';

export default function TradeInHowItWorks() {
  const steps = [
    {
      icon: 'ri-edit-line',
      title: 'Tell Us About Your Car',
      description: 'Fill out our quick form with your vehicle info. Takes about 2 minutes — less time than it takes to find your keys.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Get Your Trade-In Value',
      description: 'We\'ll send you a real offer within 24 hours. Not a "up to" fantasy number — an actual, we\'ll-honor-this-price offer.',
    },
    {
      icon: 'ri-car-line',
      title: 'Pick Your Next Ride',
      description: 'Browse our inventory and find something you\'ll actually enjoy driving. No pressure to pick today, this week, or ever.',
    },
    {
      icon: 'ri-file-paper-2-line',
      title: 'We Handle the Paperwork',
      description: 'Bring your car, sign a few things, drive home in your new ride. We\'ll deal with the DMV, payoff, and all the boring stuff.',
    },
  ];

  return (
    <HowItWorksSteps
      steps={steps}
      variant="grid"
      title="How It Works (The Non-Annoying Version)"
      subtitle="Trading in your car shouldn't feel like negotiating a hostage situation. Here's our process — simple, transparent, and refreshingly free of 'let me check with my manager' moments."
      ctaText="Start My Valuation"
      ctaHref="#trade-in-form"
      ctaNote="Most sellers have a number in hand within one business day. Some same-day."
      theme="light"
      showAnimation={false}
    />
  );
}